import { CheckCircle2 } from "lucide-react";
import type { FC } from "react";

import { LoadingState } from "@/components/brand";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle
} from "@/components/ui/empty";

import { useClientPortal } from "../components/ClientPortalShell";
import { PortalCard, TaskRows } from "../components/PortalParts";
import { usePortalT } from "../i18n";
import { sortTasks } from "../portalModel";
import { useClientPortalHome } from "../queries";
import { PortalLoadError } from "./PortalHomePage";

export const PortalTasksPage: FC = () => {
  const me = useClientPortal();
  const { t } = usePortalT();
  const home = useClientPortalHome();

  if (home.isLoading) return <LoadingState size="lg" />;
  if (!home.data)
    return <PortalLoadError onRetry={() => void home.refetch()} />;

  const tasks = sortTasks(home.data.tasks);
  return (
    <>
      <h1 className="text-2xl font-semibold tracking-tight">
        {t("tasks.title")}
      </h1>
      <PortalCard>
        {tasks.length ? (
          <TaskRows tasks={tasks} preview={me.preview} />
        ) : (
          <Empty className="p-6">
            <EmptyHeader>
              <EmptyMedia variant="icon">
                <CheckCircle2 />
              </EmptyMedia>
              <EmptyTitle>{t("tasks.none")}</EmptyTitle>
              <EmptyDescription>{t("tasks.noneBody")}</EmptyDescription>
            </EmptyHeader>
          </Empty>
        )}
      </PortalCard>
    </>
  );
};
